

export default function Spinner(){
    return(
        <div className="spinner-container">
            <div className="inner-spinner-page-container">
                <div className="sending-email-spinner"></div>
                <div className="loading-text">Sending, please don't leave this page</div>
            </div> 
        </div>
    )
}